export default {"src":"/_next/static/image/public/images/flags/flag_351.a0677f4cfe8cc85f609498b2b74da958.svg","height":16,"width":24};